module.exports = __webpack_public_path__ + "static/media/musterilerine-sesini-duyur.a2b018b3.png";